import React, { Dispatch, SetStateAction } from "react";
import {
  BehavioralProcess,
  ProcessTree
} from "../../../@types/rldynamicanalysis";

type RlCloudSandboxProcessTreeItemProps = {
  process: ProcessTree;
  activeItem: BehavioralProcess | null;
  setActiveItem: Dispatch<SetStateAction<BehavioralProcess>>;
};

const RlCloudSandboxProcessTreeItem = ({
  process,
  activeItem,
  setActiveItem
}: RlCloudSandboxProcessTreeItemProps) => {
  const { children } = process || [];
  const childrenComponents = (
    <ul>
      {children.map((item: ProcessTree, index) => (
        <RlCloudSandboxProcessTreeItem
          process={item}
          key={`${index}-${item.process_id}-${item.name}`}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
      ))}
    </ul>
  );
  const { name, parameters, process_id } = process;
  const active =
    name === activeItem?.name &&
    parameters === activeItem?.parameters &&
    process_id === activeItem?.process_id;
  return (
    <li className="process-tree__item">
      <div className="process-tree__item-container">
        <span
          onClick={() => setActiveItem({ name, parameters, process_id })}
          className={`
          process-tree__item-link 
            ${active && "active"}
            `}
        >
          {name}
        </span>{" "}
        (ID: {process_id}, parameters: {parameters})
      </div>
      {childrenComponents}
    </li>
  );
};

export default RlCloudSandboxProcessTreeItem;
